import { Link } from "react-router-dom";
import TopBar from "@/components/feature/TopBar";
import SubpageHeader from "@/components/feature/SubpageHeader";
import Footer from "@/components/feature/Footer";
import FloatingWhatsApp from "@/components/feature/FloatingWhatsApp";
import MobileCta from "@/components/feature/MobileCta";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background-50">
      <div className="fixed inset-x-0 top-0 z-50">
        <TopBar />
        <SubpageHeader />
      </div>

      <main className="pt-[140px] pb-16 md:pt-[160px] md:pb-24">
        <article className="mx-auto max-w-3xl px-4 md:px-6">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-400 hover:text-accent-300"
          >
            <i className="ri-arrow-left-line" />
            Voltar ao início
          </Link>

          <h1 className="mt-4 font-heading text-3xl font-medium leading-tight text-foreground-50 md:text-4xl">
            Política de Privacidade
          </h1>
          <p className="mt-3 text-sm text-foreground-500">Última atualização: agosto de 2026</p>

          <div className="mt-8 space-y-8 text-base leading-relaxed text-foreground-400">
            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground-50">
                1. Quem somos
              </h2>
              <p className="mt-3">
                Esta política descreve como a Dra. Sâmia Albuquerque, médica (CREMEC 16.773), com
                atuação em medicina estética em Fortaleza–CE, trata os dados pessoais fornecidos por
                meio deste site.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground-50">
                2. Quais dados coletamos
              </h2>
              <p className="mt-3">
                Coletamos apenas os dados informados por você ao preencher o formulário de
                agendamento: nome, telefone (WhatsApp), procedimento de interesse e período de
                contato preferido. Não solicitamos informações médicas sensíveis por meio do site.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground-50">
                3. Como utilizamos seus dados
              </h2>
              <p className="mt-3">
                Utilizamos seus dados exclusivamente para entrar em contato e agendar uma avaliação,
                bem como para prestar o atendimento solicitado. Não compartilhamos suas informações
                com terceiros para fins de marketing.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground-50">
                4. Base legal e consentimento
              </h2>
              <p className="mt-3">
                O envio do formulário depende do seu consentimento, nos termos da Lei Geral de
                Proteção de Dados (LGPD — Lei nº 13.709/2018). Você pode solicitar a qualquer
                momento a correção ou a exclusão dos seus dados entrando em contato pelo WhatsApp ou
                Instagram indicados no rodapé.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground-50">
                5. Cookies e rastreamento
              </h2>
              <p className="mt-3">
                Este site atualmente não utiliza cookies de rastreamento ou ferramentas de análise
                de audiência sem o seu consentimento. Eventuais recursos de análise somente serão
                ativados com o consentimento aplicável.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground-50">
                6. Seus direitos
              </h2>
              <p className="mt-3">
                Você tem o direito de acessar, corrigir, portar e excluir seus dados pessoais, além
                de revogar o consentimento a qualquer momento. Para exercer esses direitos, entre em
                contato conosco.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground-50">7. Contato</h2>
              <p className="mt-3">
                Para dúvidas sobre esta política, fale conosco pelo WhatsApp (85) 98102-2809 ou pelo
                Instagram @drasamiaalbuquerque.
              </p>
            </section>
          </div>
        </article>
      </main>

      <Footer />
      <FloatingWhatsApp />
      <MobileCta />
    </div>
  );
}